// extracted by mini-css-extract-plugin
export default {"withImage":"ContentfulCtaBanner-module__withImage__ZAF_cww"};